import { Injectable } from "@angular/core";
import { Route } from "@angular/router";
import { RoleService } from "../roles/role.service";
import { StructuredMenu } from "./sidebar-item/menu-types";

@Injectable({
  providedIn: "root",
})
export class SidebarService {
  constructor(private roleService: RoleService) {}

  public async getMenusForLoggedUser(): Promise<Route[]> {
    let routes: Route[];

    await this.roleService.getMenusByCurrentUser().forEach((response) => {
      const listedMenus: Record<string, StructuredMenu> = {};
      const structuredMenus: Array<StructuredMenu> = [];

      response.result.forEach((item) => {
        listedMenus[item.menu_id] = item;
        if (item.menu_id.indexOf(".") == -1) structuredMenus.push(item);
        else {
          let parentMenuId = item.menu_id.substring(
            0,
            item.menu_id.lastIndexOf(".")
          );
          let parentMenu = listedMenus[parentMenuId];
          let i = 0;
          while (!parentMenu && !(parentMenuId == "")) {
            parentMenuId = parentMenuId.substring(
              0,
              parentMenuId.lastIndexOf(".")
            );
            parentMenu = listedMenus[parentMenuId];
          }
          if (parentMenu) {
            if (parentMenu.children) parentMenu.children.push(item);
            else parentMenu.children = [item];
          }
        }
      });

      routes = structuredMenus.map((menu) => this.buildMenuItems(menu));
    });

    return routes;
  }

  private buildMenuItems = (menu?: StructuredMenu | StructuredMenu[]) => {
    if (!menu) return;
    if (!Array.isArray(menu))
      return {
        path: menu.url,
        data: {
          id: menu.menu_id,
          title: menu.menu_title,
          icon: menu.icon,
          collapse: menu.collapse,
          reportId: menu.reportid,
          groupId: menu.groupid,
          datasetId: menu.datasetid,
          pageName: menu.pagename,
        },
        children: this.buildMenuItems(menu.children),
      };
    else return menu.map((item) => this.buildMenuItems(item));
  };
}
